/**************************************************
 * Nombre:       Footer
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, IconButton, Typography} from "@mui/material";
import {CONTACTOS, REDES, SECCIONES} from "../Constantes";
import {useResponsive} from "../Modulo_responsive/Hooks/useResponsive";
import {scrolearAComponente} from "../Utilidades/scrolearAComponente";
import {irUrl} from "../Utilidades/irUrl";

const Footer = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{maxWidth: '1400px', px: 3, py: 2}}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}>


                <Grid container size={{xs: 12, sm: 12, md: 11}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>


                        <Grid container size={{xs: 12, sm: 5, md: 5}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                                    <Typography sx={{fontSize: 24, fontWeight: 800}}>JOSE ARTURO LOPEZ</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 9}} sx={{mt: 2}}>
                                    <Typography sx={{fontSize: 16, fontWeight: 400}}>Experto en estrategias de branding
                                        y
                                        creación de marcas</Typography>
                                </Grid>


                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 3, md: 2}} sx={{mt: sCell ? 4 : 0}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mb: 3}}>
                                    <Typography sx={{fontSize: 16, fontWeight: 800}}>SECCIONES</Typography>
                                </Grid>

                                {SECCIONES.map((item, index) => {
                                    return (
                                        <Grid
                                            onClick={() => scrolearAComponente(item)}
                                            container size={12}
                                            sx={{cursor: 'pointer'}}>
                                            <Typography sx={{fontSize: 16, fontWeight: 400}}>
                                                {item}
                                            </Typography>
                                        </Grid>
                                    )
                                })}


                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 3, md: 3}} sx={{mt: sCell ? 4 : 0}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mb: 3}}>
                                    <Typography sx={{fontSize: 16, fontWeight: 800}}>CONTACTOS</Typography>
                                </Grid>

                                {CONTACTOS.map((item, index) => {
                                    return (
                                        <Grid container size={{xs: 12, sm: 12, md: 12}}>
                                            <Typography sx={{fontSize: 16, fontWeight: 400}}>
                                                {`${item.nombre} : ${item.texto}`}
                                            </Typography>
                                        </Grid>
                                    )
                                })}


                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 5, md: 2}} sx={{mt: sCell ? 4 : 0}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mb: 3}}>
                                    <Typography sx={{fontSize: 16, fontWeight: 800}}>REDES SOCIALES</Typography>
                                </Grid>

                                {REDES.map((item, index) => {
                                    return (
                                        <Grid container size={{xs: 2, ms: 3, md: 3}}
                                              sx={{justifyContent: 'flex-start'}}>
                                            <IconButton
                                                onClick={() => irUrl(item.url)}
                                            >
                                                <img src={item.icono} width={32} height={'auto'}/>
                                            </IconButton>
                                        </Grid>
                                    )
                                })}


                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'} sx={{mt: 6}}>
                            <Typography sx={{color: '#939393'}}>© Copyright 2025 - 2026 | Jose Arturo</Typography>
                        </Grid>

                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Footer